module.exports = __webpack_public_path__ + "static/motive-hero-0b8ef58ecf1a809216ec3b15fd666024.webp";